
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9m5D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b25e149e99979c$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $lO7zi = parcelRequire("lO7zi");

var $hCdov = parcelRequire("hCdov");
class $c1b25e149e99979c$export$2e2bcd8739ae039 {
    cCoord;
    center = new (0, $lO7zi.default)("O");
    tags = [];
    constructor(cCoord, tags){
        this.cCoord = cCoord;
        this.tags = tags.map((tag)=>new (0, $lO7zi.default)(tag));
        this.updateCenter();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    updateCenter = ()=>this.center.updateCoord({
            x: this.cCoord.x + 21,
            y: this.cCoord.y + 21
        });
    setAllVisible = (visible)=>[
            this.center,
            ...this.tags
        ].forEach((pTag)=>pTag.visible = visible);
    updateCoord(radians, radius) {
        const coords = (0, $hCdov.default)(this.cCoord, radians, radius + 30);
        coords.forEach((coord, cI)=>this.tags[cI].updateCoord(coord));
    }
}

});

parcelRegister("f8pkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5728371334eb545$export$2e2bcd8739ae039);

var $g4gW0 = parcelRequire("g4gW0");

var $a92Ax = parcelRequire("a92Ax");

var $eP48i = parcelRequire("eP48i");

var $erVR3 = parcelRequire("erVR3");
class $a5728371334eb545$export$2e2bcd8739ae039 {
    rootEventBus = (0, $erVR3.rootEventBus);
    EnumRootEventBus = (0, $erVR3.EnumRootEventBus);
    Angles = [];
    constructor(anglePropsArr, followCircleAnim = true){
        this.Angles = anglePropsArr.map((angleProps, aI)=>new (0, $g4gW0.default)(`a${aI + 1}`, angleProps.angleColors, angleProps.smallDistanceOffset, angleProps.addCon, angleProps.addSmallDis));
        if (followCircleAnim) {
            this.rootEventBus.on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
            this.rootEventBus.on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
        }
    }
    setAllVisible = (v)=>this.Angles.forEach((angle)=>angle.setVisible(v));
    getAngles = ()=>this.Angles;
    drawAngle(angle, p, degree, clockwise) {
        const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
        const smllDistance = Math.floor(Math.min((0, $eP48i.default)(p.curr, p.prev), (0, $eP48i.default)(p.curr, p.next)));
        angle.smallDistance = smllDistance;
        angle.draw(p.curr, startRadian, endRadian, degree, !clockwise);
        angle.x = p.curr.x;
        angle.y = p.curr.y;
        angle.rotation = 0;
    }
}

});
parcelRegister("g4gW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d65a8310461d1d$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $i30uN = parcelRequire("i30uN");

var $3f3J1 = parcelRequire("3f3J1");
class $b0d65a8310461d1d$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    AngleValue;
    arc;
    arcStroke;
    tag;
    startRadian;
    endRadian;
    degree;
    fillColor;
    smallDistance = 100;
    smallDistanceOffset = 0;
    addSmallDis = true;
    constructor(tag, angleColor, smallDistanceOffset = 0, addCon = false, addSmallDis = true){
        super();
        this.tag = tag;
        this.fillColor = angleColor.color;
        this.smallDistanceOffset = smallDistanceOffset;
        this.addSmallDis = addSmallDis;
        this.AngleValue = new (0, $i30uN.default)({
            x: -100,
            y: -100
        }, angleColor.textColor);
        this.addArc();
        !addCon && this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    addArc() {
        this.arc = new $iuB9z.Graphics();
        this.addChild(this.arc);
        this.arcStroke = new $iuB9z.Graphics();
        this.addChild(this.arcStroke);
    }
    setVisible(status) {
        this.visible = status;
        this.AngleValue.visible = status;
    }
    draw(cCoord, startRadian, endRadian, degree, cClockwise) {
        const sD = this.smallDistance;
        const radian = sD <= 76 + this.smallDistanceOffset && this.addSmallDis ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
        this.degree = degree;
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        if (degree == 90) {
            this.arcStroke.clear();
            (0, $3f3J1.drawSquare)(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
        } else {
            (0, $3f3J1.drawArc)(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
            (0, $3f3J1.drawArc)(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false);
        }
        const initialAngle = cClockwise ? endRadian : startRadian;
        this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
    }
}

});
parcelRegister("i30uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6935df93860f2c37$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $eymUv = parcelRequire("eymUv");
class $6935df93860f2c37$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(coord, color){
        super();
        this.text = "60\xb0";
        this.style.fill = color;
        this.style.fontSize = 34;
        this.style.fontWeight = "800";
        this.anchor.set(.5);
        this.setAngleValue(coord, 0, 0, 38);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Top.addChild(this);
    setValue = (value)=>this.text = `${value}\xb0`;
    setAngleValue(cCoord, initialAngle, degree, radian) {
        const angle = initialAngle + (0, $eymUv.default)(degree / 2);
        const coord = {
            x: Math.cos(angle) * radian * 1.7 + cCoord.x,
            y: Math.sin(angle) * radian * 1.7 + cCoord.y
        };
        this.setValue(degree);
        this.style.fontSize = radian;
        this.x = coord.x;
        this.y = coord.y;
    }
}

});
parcelRegister("eymUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afd35e271dc067b$export$2e2bcd8739ae039);
function $0afd35e271dc067b$export$2e2bcd8739ae039(degree) {
    return degree * (Math.PI / 180);
}

});


parcelRegister("3f3J1", function(module, exports) {

$parcel$export(module.exports, "drawArc", () => $827e00f616855d7e$export$bf8a3f9983094125);
$parcel$export(module.exports, "drawSquare", () => $827e00f616855d7e$export$9340b6a85ea854b9);
function $827e00f616855d7e$export$bf8a3f9983094125(arc, r, sRadian, eRadian, w, color, cClockwise, isStroke) {
    arc.clear();
    if (!isStroke) arc.arc(0, 0, r, sRadian, eRadian, cClockwise).stroke({
        width: w,
        color: color
    });
    else arc.moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r).lineTo(0, 0).arc(0, 0, r, sRadian, eRadian, cClockwise).moveTo(0, 0).lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r).stroke({
        width: w,
        color: color
    });
    arc.rotation = 0;
}
function $827e00f616855d7e$export$9340b6a85ea854b9(square, dim, startRadian, endRadian, color, cClockwise) {
    square.clear();
    square.rect(0, 0, dim, dim).fill(color).stroke({
        color: 0x000000,
        width: 3
    });
    square.rotation = !cClockwise ? startRadian : endRadian;
}

});


parcelRegister("a92Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2e4f2e6d187ae4$export$2e2bcd8739ae039);

var $2h5MD = parcelRequire("2h5MD");
function $1f2e4f2e6d187ae4$export$2e2bcd8739ae039(cCoord, coordStart, coordEnd) {
    const startRadian = (0, $2h5MD.default)(cCoord, coordStart);
    const endRadian = (0, $2h5MD.default)(cCoord, coordEnd);
    return {
        startRadian: startRadian,
        endRadian: endRadian
    };
}

});


parcelRegister("eitLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $295d8ae516c805d1$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");

var $gcphA = parcelRequire("gcphA");
class $295d8ae516c805d1$export$2e2bcd8739ae039 {
    CheckboxRenderer;
    isChecked = false;
    checkBoxLabel;
    handleFunc;
    constructor(coord, label, color, useCustomLayer = false, handleFunc = (label, v)=>{}){
        this.CheckboxRenderer = new (0, $gcphA.default)(color, label, useCustomLayer);
        Object.assign(this.CheckboxRenderer, coord);
        this.handleFunc = handleFunc;
        this.addInteractivity();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    addToCon = (con)=>con.addChild(this.CheckboxRenderer);
    setScale = (v)=>this.CheckboxRenderer.con.scale.set(v);
    setVisible = (v)=>this.CheckboxRenderer.visible = v;
    addInteractivity() {
        const handleUpFunc = ()=>this.handleCheckbox();
        (0, $16Wgx.default)(this.CheckboxRenderer, {
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    handleCheckbox() {
        this.isChecked = !this.isChecked;
        this.handleFunc(this.checkBoxLabel, this.isChecked);
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
    getIsChecked() {
        return {
            label: this.checkBoxLabel,
            isChecked: this.isChecked
        };
    }
    setChecked(v) {
        this.isChecked = v;
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
}

});
parcelRegister("gcphA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f182ab57cf75ac$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $c6f182ab57cf75ac$export$2e2bcd8739ae039 extends $iuB9z.Container {
    color;
    checkboxLabel;
    Layers;
    con;
    checkedSquare;
    defaultColor;
    constructor(color, checkboxLabel, useCustomLayer = false){
        super(), this.color = color, this.checkboxLabel = checkboxLabel, this.Layers = (0, $9ec1t.default).getInstance(), this.con = this.addChild(new $iuB9z.Container()), this.checkedSquare = this.con.addChild(new $iuB9z.Graphics()), this.defaultColor = 0xFFFFFF, this.addToLayer = ()=>this.Layers.UI.addChild(this);
        this.drawCheckbox(false);
        this.addLabel();
        !useCustomLayer && this.addToLayer();
    }
    addToLayer;
    drawCheckbox(isColored) {
        const fillColor = isColored ? this.color : this.defaultColor;
        this.checkedSquare.clear().roundRect(0, -20, 40, 40, 10).fill(fillColor).stroke({
            width: 2,
            color: 0x000000
        });
    }
    addLabel() {
        const text = new $iuB9z.Text({
            text: this.checkboxLabel
        });
        text.style.fontSize = 36;
        text.style.fill = this.color;
        text.anchor.set(0, .5);
        text.x = 50;
        text.y = 0;
        this.con.addChild(text);
    }
}

});


parcelRegister("jISXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66faaaf67ef5cb50$export$2e2bcd8739ae039);
function $66faaaf67ef5cb50$export$2e2bcd8739ae039(dim, CENTER_OF_CIRCLE) {
    if (dim.WIDTH > dim.HEIGHT) return CENTER_OF_CIRCLE;
    return {
        x: dim.WIDTH / 2,
        y: dim.HEIGHT / 2
    };
}

});

parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $75RpY = parcelRequire("75RpY");

var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");

var $iuB9z = parcelRequire("iuB9z");
var $3517df55547f91be$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["moveCircumPoint"] = "MOVE_CIRCUMFERENCE_POINT";
    EnumEventBus["setTangentType"] = "SET_TANGENT_TYPE";
    return EnumEventBus;
}({});
const $3517df55547f91be$export$f6644f0f2c90144b = new (0, $iuB9z.EventEmitter)();



var $fGH3X = parcelRequire("fGH3X");

var $iiVV4 = parcelRequire("iiVV4");

var $5ehzb = parcelRequire("5ehzb");


var $hCdov = parcelRequire("hCdov");

var $darcK = parcelRequire("darcK");
const $09478d1e8804267d$export$7a003cdef7722780 = [
    0xFC99C4,
    0xF94F6F
];
const $09478d1e8804267d$export$c7609d9da8d80867 = {
    x: 600,
    y: 310
};
const $09478d1e8804267d$export$ca8f2c484d507a5d = 200;
const $09478d1e8804267d$export$95c476c8e1b0007 = [
    Math.PI / 2
];
const $09478d1e8804267d$export$bdea539c223eec51 = [
    0x000000,
    0x000000
];
const $09478d1e8804267d$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $09478d1e8804267d$export$186dbbe504e85fe1 = [
    {
        x: 460,
        y: 800
    }
];
const $09478d1e8804267d$export$75f2cc8245aafe09 = [
    {
        x: 100,
        y: 420
    }
];
const $09478d1e8804267d$export$b557e8cf7c04a93a = {
    x: 100,
    y: 780
};
const $09478d1e8804267d$export$b8ccf4a47999ced5 = {
    x: -330,
    y: 400
};
const $09478d1e8804267d$export$2e51dc0dfab2d766 = "circle-theorem-6";


var $bcc8ef1d7a94cf95$export$4aefcaabf9c6c070 = /*#__PURE__*/ function(TangentType) {
    TangentType["type1"] = "TYPE1";
    TangentType["type2"] = "TYPE2";
    return TangentType;
}({});


class $ffd7c53d7d3a5394$export$2e2bcd8739ae039 extends (0, $5ehzb.default) {
    tangentType = (0, $bcc8ef1d7a94cf95$export$4aefcaabf9c6c070).type1;
    constructor(cCoord){
        super(cCoord, (0, $09478d1e8804267d$export$ca8f2c484d507a5d), (0, $09478d1e8804267d$export$95c476c8e1b0007));
        this.setCoord();
        this.draw();
        (0, $3517df55547f91be$export$f6644f0f2c90144b).on((0, $3517df55547f91be$export$cb883390c27ec6dd).moveCircumPoint, (v)=>this.handleMoveCircumPointSlider(v));
        (0, $3517df55547f91be$export$f6644f0f2c90144b).on((0, $3517df55547f91be$export$cb883390c27ec6dd).setTangentType, (v)=>this.tangentType = v);
    }
    handleMoveCircumPointSlider(v) {
        const points = this.getRedPoints();
        const refRadians = this.getRefRadians();
        const radian = refRadians[0] + Math.PI / 90 * v;
        const pointInfo = {
            pTag: points[0].tag,
            radian: radian
        };
        this.setRadian([
            pointInfo
        ], true);
    }
    getTangentCoords() {
        const pointARadian = this.getRadians()[0];
        const pointA = this.getRedPointsCoord()[0];
        const _radian = pointARadian + Math.PI / 2;
        const radians = [
            (0, $darcK.normalizeRadian)(_radian),
            (0, $darcK.normalizeRadian)(_radian + Math.PI)
        ];
        const tangentCoords = (0, $hCdov.default)(pointA, radians, 150);
        return this.tangentType == (0, $bcc8ef1d7a94cf95$export$4aefcaabf9c6c070).type1 ? tangentCoords : [
            pointA,
            tangentCoords[1]
        ];
    }
}



var $9m5D8 = parcelRequire("9m5D8");
class $9e3e926848cba025$export$2e2bcd8739ae039 extends (0, $9m5D8.default) {
    constructor(cCoord){
        super(cCoord, [
            "A"
        ]);
    }
}



var $d0yDD = parcelRequire("d0yDD");

var $erVR3 = parcelRequire("erVR3");
class $cc3a42bc2d04c822$export$2e2bcd8739ae039 {
    cCoord;
    lines;
    constructor(cCoord){
        this.cCoord = cCoord;
        this.lines = [
            new (0, $d0yDD.default)(),
            new (0, $d0yDD.default)({
                color: 0xb06efe
            })
        ];
        this.clearAll = ()=>this.lines.forEach((l)=>l.clear());
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.clearAll());
    }
    clearAll;
    draw(points, tangentPointCoords) {
        this.lines[0].draw(this.cCoord, points[0]);
        this.lines[1].draw(tangentPointCoords[0], tangentPointCoords[1]);
    }
}



var $f8pkD = parcelRequire("f8pkD");

const $7aeb54bc4fdd77f7$var$pAC = (0, $09478d1e8804267d$export$7a003cdef7722780);
class $7aeb54bc4fdd77f7$export$2e2bcd8739ae039 extends (0, $f8pkD.default) {
    cCoord;
    constructor(cCoord){
        const anglePropsArr = Array(1).fill(null).map((_)=>({
                angleColors: {
                    color: $7aeb54bc4fdd77f7$var$pAC[0],
                    textColor: $7aeb54bc4fdd77f7$var$pAC[1]
                },
                smallDistanceOffset: 20,
                addSmallDis: false
            }));
        super(anglePropsArr), this.cCoord = cCoord;
        this.cCoord = cCoord;
    }
    draw(points, tangentPoints, clockwise = true) {
        const Points = {
            curr: points[0],
            prev: this.cCoord,
            next: tangentPoints[0]
        };
        const degree = 90;
        this.drawAngle(this.Angles[0], Points, degree, clockwise);
    }
}



var $b2sIL = parcelRequire("b2sIL");


const $b7d5827e42139e66$var$SliderGen = [
    {
        head: "move circumference point",
        colors: {
            bgColor: 0xB5A1FF,
            barColor: 0x000000,
            buttonColor: 0xB5A1FF
        },
        onUpdate: (v)=>(0, $3517df55547f91be$export$f6644f0f2c90144b).emit((0, $3517df55547f91be$export$cb883390c27ec6dd).moveCircumPoint, v - 100)
    }
];
class $b7d5827e42139e66$export$2e2bcd8739ae039 extends (0, $b2sIL.default) {
    pointCheckboxes = [];
    pointChecklist = Array(2).fill(false);
    constructor(){
        super($b7d5827e42139e66$var$SliderGen, (0, $09478d1e8804267d$export$186dbbe504e85fe1), (0, $09478d1e8804267d$export$75f2cc8245aafe09));
    }
}



var $3DpJv = parcelRequire("3DpJv");

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $erVR3 = parcelRequire("erVR3");


var $eitLW = parcelRequire("eitLW");


class $ca0199aaa3cf928a$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    type1;
    type2;
    constructor(){
        super();
        this.addCoord();
        this.addCheckboxes();
        this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    setVisible = (v)=>this.visible = v;
    isPortial() {
        const dim = this.Game.getDim();
        return dim.HEIGHT > dim.WIDTH;
    }
    addCoord() {
        const dim = this.Game.getDim();
        let coord = (0, $09478d1e8804267d$export$b557e8cf7c04a93a);
        if (this.isPortial()) coord = {
            x: dim.WIDTH / 2 + (0, $09478d1e8804267d$export$b8ccf4a47999ced5).x,
            y: dim.HEIGHT / 2 + (0, $09478d1e8804267d$export$b8ccf4a47999ced5).y
        };
        Object.assign(this, coord);
    }
    addCheckboxes() {
        const isPortial = this.isPortial();
        this.type1 = new (0, $eitLW.default)({
            x: 0,
            y: 0
        }, "Tangent Type 1", 0xf94f6f, true, ()=>{
            this.type2.setChecked(false);
            (0, $3517df55547f91be$export$f6644f0f2c90144b).emit((0, $3517df55547f91be$export$cb883390c27ec6dd).setTangentType, (0, $bcc8ef1d7a94cf95$export$4aefcaabf9c6c070).type1);
        });
        this.type1.setScale(isPortial ? 1 : .7);
        this.type1.setChecked(true);
        this.type2 = new (0, $eitLW.default)({
            x: 0,
            y: isPortial ? 52 : 36
        }, "Tangent Type 2", 0xf94f6f, true, ()=>{
            this.type1.setChecked(false);
            (0, $3517df55547f91be$export$f6644f0f2c90144b).emit((0, $3517df55547f91be$export$cb883390c27ec6dd).setTangentType, (0, $bcc8ef1d7a94cf95$export$4aefcaabf9c6c070).type2);
        });
        this.type2.setScale(isPortial ? 1 : .7);
        [
            this.type1,
            this.type2
        ].forEach((c)=>c.addToCon(this));
    }
}



var $erVR3 = parcelRequire("erVR3");

var $iD90R = parcelRequire("iD90R");


var $darcK = parcelRequire("darcK");
async function $736943d896621c00$export$2721aded6352b5ea(context, onComp) {
    const { circle: circle, LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager, cCoord: cCoord } = context;
    const centerPoint = PointManager.getPoints()[0];
    const centerPointCoord = PointManager.getPointsCoord()[0];
    const pointsCoord = PointManager.getRedPointsCoord();
    const tangentCoords = PointManager.getTangentCoords();
    const RedPoints = PointManager.getRedPoints();
    const initialRadian = PointManager.getInitialRadians();
    const angles = AngleManager.getAngles();
    AngleManager.draw(pointsCoord, tangentCoords);
    circle.radians = [
        ...(0, $09478d1e8804267d$export$95c476c8e1b0007),
        ...(0, $09478d1e8804267d$export$95c476c8e1b0007)
    ];
    (0, $iD90R.drawPointsAnim)([
        centerPoint
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $09478d1e8804267d$export$95c476c8e1b0007)[0] + Math.PI * 2, 0, true, cCoord);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[0], centerPointCoord, pointsCoord[0]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[1], tangentCoords[0], tangentCoords[1]);
    (0, $iD90R.drawAngleAnim)(angles[0], "90");
    await (0, $iD90R.rotateCircleAnim)((v)=>{
        const arr = Array(1).fill(v).map((v, vI)=>({
                pTag: RedPoints[vI].tag,
                radian: (0, $darcK.normalizeRadian)(initialRadian[vI] + v)
            }));
        PointManager.setRadian(arr);
    });
    await (0, $iD90R.drawPointsAnim)(RedPoints);
    onComp();
}



var $e8wW1 = parcelRequire("e8wW1");

class $0965aba7b84e1c07$export$2e2bcd8739ae039 {
    PointManager;
    AngleManager;
    LineManager;
    circle;
    cCoord;
    constructor(PointManager, AngleManager, LineManager, circle, cCoord){
        this.PointManager = PointManager;
        this.AngleManager = AngleManager;
        this.LineManager = LineManager;
        this.circle = circle;
        this.cCoord = cCoord;
        this.addCircAnimBut = ()=>new (0, $e8wW1.default)((0, $09478d1e8804267d$export$840ec2322406bfdd), ()=>this.runAnimations());
        this.addCircAnimBut();
    }
    addCircAnimBut;
    runAnimations() {
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).startedCircleAnim);
        const context = {
            PointManager: this.PointManager,
            AngleManager: this.AngleManager,
            LineManager: this.LineManager,
            circle: this.circle,
            cCoord: this.cCoord
        };
        (0, $736943d896621c00$export$2721aded6352b5ea)(context, ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).completedCircleAnim);
        });
    }
}



var $jISXQ = parcelRequire("jISXQ");

class $2b5d58661b6c0889$export$2e2bcd8739ae039 {
    static instance;
    Game = (0, $75RpY.default).getInstance();
    circleRadius = (0, $09478d1e8804267d$export$ca8f2c484d507a5d);
    cCoord = (0, $jISXQ.default)(this.Game.getDim(), (0, $09478d1e8804267d$export$c7609d9da8d80867));
    PointManager = new (0, $ffd7c53d7d3a5394$export$2e2bcd8739ae039)(this.cCoord);
    PointTagManager = new (0, $9e3e926848cba025$export$2e2bcd8739ae039)(this.cCoord);
    LineManager = new (0, $cc3a42bc2d04c822$export$2e2bcd8739ae039)(this.cCoord);
    AngleManager = new (0, $7aeb54bc4fdd77f7$export$2e2bcd8739ae039)(this.cCoord);
    circle = new (0, $iiVV4.default)(this.cCoord, [
        ...(0, $09478d1e8804267d$export$95c476c8e1b0007),
        ...(0, $09478d1e8804267d$export$95c476c8e1b0007)
    ], (0, $09478d1e8804267d$export$bdea539c223eec51));
    guideText = new (0, $3DpJv.default)(undefined, true);
    InfoSlider = new (0, $fGH3X.default)((0, $09478d1e8804267d$export$840ec2322406bfdd));
    CircleAnimationManager;
    SliderManager = new (0, $b7d5827e42139e66$export$2e2bcd8739ae039)();
    TangentTypeCon = new (0, $ca0199aaa3cf928a$export$2e2bcd8739ae039)();
    constructor(){
        this.CircleAnimationManager = new (0, $0965aba7b84e1c07$export$2e2bcd8739ae039)(this.PointManager, this.AngleManager, this.LineManager, this.circle, this.cCoord);
        this.drawElements();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).drawElements, ()=>this.drawElements());
        (0, $3517df55547f91be$export$f6644f0f2c90144b).on((0, $3517df55547f91be$export$cb883390c27ec6dd).setTangentType, ()=>setTimeout(()=>this.drawElements(), 100));
    }
    drawElements() {
        const radians = this.PointManager.getRadians();
        const redPointsCoord = this.PointManager.getRedPointsCoord();
        const tangentPointCoords = this.PointManager.getTangentCoords();
        this.circle.draw({
            radians: radians,
            radius: this.circleRadius
        });
        this.PointTagManager.updateCoord(radians, this.circleRadius);
        this.LineManager.draw(redPointsCoord, tangentPointCoords);
        this.AngleManager.draw(redPointsCoord, tangentPointCoords);
    }
}



const $2d621056cf5f0a74$var$canvas = document.querySelector("#canvas");
if ($2d621056cf5f0a74$var$canvas) window.context = new (0, $75RpY.default)($2d621056cf5f0a74$var$canvas, (0, $09478d1e8804267d$export$2e51dc0dfab2d766), ()=>new (0, $2b5d58661b6c0889$export$2e2bcd8739ae039)());
else console.error("Canvas is not found");


//# sourceMappingURL=index.aa4cd50b.js.map
